import { render, staticRenderFns } from "./spinner-button.vue?vue&type=template&id=f04edc2c&"
import script from "./spinner-button.vue?vue&type=script&lang=js&"
export * from "./spinner-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/planorama/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f04edc2c')) {
      api.createRecord('f04edc2c', component.options)
    } else {
      api.reload('f04edc2c', component.options)
    }
    module.hot.accept("./spinner-button.vue?vue&type=template&id=f04edc2c&", function () {
      api.rerender('f04edc2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/shared/spinner-button.vue"
export default component.exports